import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography, TertiaryButton, ContentLoader, TertiaryButtonGroup, palette } from '@dev/ee-components';
import styled from 'styled-components';
import { useMobile } from '@api/services/hooks/useMobile';

import { getEmailsStore } from '@api/store/emails/actions';
import { ShowDialog } from '@api/store/dialog/actions';

import { ShowDialogParams } from '@api/store/dialog/types';
import { useSmsData } from '../hooks/useSMSData';
import { ViewEmailComonentsProps } from '../ViewEmailProps';

const HeadersEmailModal = styled.div<{ isMobile: boolean }>`
    border: 1px solid ${palette.gray[3]};
    border-radius: 4px;
    padding: ${(props): string => (props.isMobile ? '16px 20px' : '32px 48px')};
    word-break: break-all;
    white-space: pre-wrap;
`;

const HeaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 8px;
    margin-bottom: 32px;
    > div:first-child,
    > span:first-child {
        margin-bottom: 8px;
    }
`;

const Header = (props: ViewEmailComonentsProps): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = useMobile();

    const { email, emailLoading } = useSelector(getEmailsStore);
    const smsData = props.isSmsScreen && useSmsData(props.msgId);

    const showInNewWindow = (): void => {
        const EmailPreview = window.open('', 'EmailPreview');
        EmailPreview.document.write(email?.Preview?.Body);
    };

    const showEmailHeaders = (): void => {
        const headers = (
            <HeadersEmailModal isMobile={isMobile}>
                <Typography variant="body1" bodyVariant="onPaper">
                    {email.Headers}
                </Typography>
            </HeadersEmailModal>
        );

        const params: ShowDialogParams = {
            title: t('emailheaders'),
            cancelLabel: t('close'),
            body: headers,
        };
        dispatch(ShowDialog(params));
    };

    return (
        <HeaderWrapper>
            {emailLoading ? (
                <ContentLoader mode="row" height={38} width={300} />
            ) : (
                <Typography variant="h1">{email?.Preview?.Subject || smsData.To}</Typography>
            )}
            <TertiaryButtonGroup>
                <TertiaryButton onClick={showInNewWindow} text={t('viewinnewwindow')} />
                <TertiaryButton onClick={showEmailHeaders} text={t('emailheaders')} />
            </TertiaryButtonGroup>
        </HeaderWrapper>
    );
};

export default Header;
